import React from 'react';
import './App.css';
import H1 from './Elements/H1';
import H2 from './Elements/H2';
import './ScheduleCell.css';

const dateDiff = (date1: Date, date2: Date) => {
    const diffTime = date2.getTime() - date1.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
}

const YMA = () => {
    const today = new Date();
    const eventDate = new Date(2025, 9, 25);
    const diffDays = dateDiff(today, eventDate);

    return <>
        <H1>天理教青年会総会@髙安分会</H1>
        <div className="content-scroll pl-1">
            <p className="copy">あの人のためにおぢばへ。たすかってほしい人がいる。<br/>
ずっと元気でいてほしい人がいる。幸せを願っている人がいる。<br/>
忙しい毎日の中でも、その人のことが頭から離れない。<br/>
その人のたすかりを願い、僕らはおぢばに帰る。<br/>
そうだ。おぢばは「たすかる」ところだ。いつでも教祖がそばにいて、<br/>
僕たちを導いてくださる。そして僕たちをおぢばでお待ちくださっている。<br/>
さぁ、いこう。心を澄ます毎日の、その先に。</p>

        <div>
            {diffDays > 0 && <>
                <p>総会まであと</p>
                <p className="countDown">
                    {diffDays}日
                </p>
            </>}

            {diffDays === 0 && <p className="countDown">今日は総会当日です</p>}
        </div>
        <H2>総会スケジュール</H2>
        <div className="schedule-row add">
            <div>12:00</div>
            <div>詰所集合・受付</div>
            <div>詰所1階ロビー</div>
        </div>

        <div className="schedule-row odd">
            <div>13:00-14:30</div>
            <div>式典</div>
            <div>本部中庭</div>
        </div>

        <div className="schedule-row add">
            <div>15:00-16:00</div>
            <div><strong>選択行事</strong></div>
            <div>笑いと感動の演劇公演！</div>
        </div>

        <div className="schedule-row add">
            <div></div>
            <div>十二下りお願いづとめ</div>
            <div>百母屋</div>
        </div>

        <div className="schedule-row add">
            <div></div>
            <div>ねりあい</div>
            <div>髙安詰所6開堂</div>
        </div>

        <div className="schedule-row odd">
            <div>16:00-20:30</div>
            <div>模擬店</div>
            <div>詰所前</div>
        </div>

        <div className="schedule-row add">
            <div>21:30-</div>
            <div>二次会</div>
            <div>詰所2階中広間</div>
        </div>

        <div className="schedule-row odd">
            <div>翌26日-</div>
            <div>本部大祭</div>
            <div>本部神殿</div>
        </div>

        <br/>
        <br/>
        <ul>
            <li>総会当日、翌日大祭は駐車場が混み合いますので、お近くの本部駐車場などにお止めください。</li>
            <li>上記スケジュール時間以外も、ご参加可能な方はひのきしんのご協力をお願い致します。</li>
            <li>宿泊される方は事前に詰所まで宿泊予約をお願い致します。</li>
        </ul>
    </div>
</>
}

export default YMA;